import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {OrganizationComponent} from "./organization.component";
import {AdministrationUnitSelectionComponent} from "./administration_unit/administration-unit-selection/administration-unit-selection.component";
import {AdministrationUnitService} from "./services/administration_unit_service/administration-unit.service";
import {ReactiveFormsModule} from "@angular/forms";
import {VisbosCoreModule} from "../core/visbos-core/visbos-core.module";
import { AdministrationUnitsListComponent } from './administration_unit/administration-units-list/administration-units-list.component';

@NgModule({
  imports: [
    CommonModule, ReactiveFormsModule, VisbosCoreModule
  ],
  providers: [AdministrationUnitService],
  declarations: [OrganizationComponent, AdministrationUnitSelectionComponent, AdministrationUnitsListComponent],
  exports: [AdministrationUnitSelectionComponent, AdministrationUnitsListComponent]
})
export class OrganizationModule {
}



// WEBPACK FOOTER //
// ./src/app/organization/organization.module.ts